import React from "react";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Select from "react-select";
import { useQuery } from "@apollo/client";
import {
  VEHICLE_CAPACITIES,
  VEHICLE_COLORS,
  VEHICLE_TYPES,
  VEHICLE_EXTRA_FEATURES,
} from "../../apollo/operations";
import Loading from "../loading/Loading";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import the styles
import { RootState } from "../../redux/store";
import { stripHtml } from "../../utils/splitStringByComma";

const VinDetails: React.FC = () => {
  const vinDetails = useSelector(
    (state: RootState) => state.addVehicle.Vehicle[0]
  );
  // console.log(vinDetails);
  // const [vinState, setVinState] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // getMonth() returns a zero-based value (where 0 indicates the first month of the year)
  const formattedMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}`; // padStart ensures the month is always 2 digits

  const {
    data: capacity,
    error: capacityError,
    loading: capacityLoading,
  } = useQuery(VEHICLE_CAPACITIES);

  const {
    data: colors,
    error: colorsError,
    loading: colorsLoading,
  } = useQuery(VEHICLE_COLORS);

  const {
    data: types,
    error: typesError,
    loading: typesLoading,
  } = useQuery(VEHICLE_TYPES);

  const {
    data: features,
    error: featuresError,
    loading: featuresLoading,
  } = useQuery(VEHICLE_EXTRA_FEATURES);

  // console.log(capacity);
  if (
    loading ||
    capacityLoading ||
    colorsLoading ||
    typesLoading ||
    featuresLoading
  )
    return (
      <Loading
        loading={
          loading ||
          capacityLoading ||
          colorsLoading ||
          typesLoading ||
          featuresLoading
        }
      />
    );

  return (
    <>
      <div className="flex w-[80%] lg:w-[70%] py-10 border rounded-2xl mx-auto justify-center  h-full  flex-col gap-4 lg:items-center  bg-white">
        <p className=" text-black text-center font-Poppins font-semibold lg:font-medium text-[25px] lg:text-[40px]  ">
          Let your car work for you
        </p>
        <div className="flex flex-col  gap-12 w-[90%] mx-auto  lg:w-2/3 ">
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2 flex-col">
              <label htmlFor="" className=" block ">
                VIN
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="VIN"
                value={vinDetails?.vin ?? ""}
                required
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      vin: e.target.value,
                    })
                  );
                  // setVinState(e.target.value);
                }}
              />
            </div>
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Vehicle Brand
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Vehicle Brand"
                required
                value={vinDetails?.vehicleBrand ?? ""}
                min={formattedMonth}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      vehicleBrand: e.target.value,
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Model
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Model"
                required
                value={vinDetails?.model ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      model: e.target.value,
                    })
                  );
                }}
              />
            </div>
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Vehicle Type
              </label>
              {/* <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Vehicle Type"
                required
                value={vinDetails?.vehicleType}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      vehicleType: e.target.value,
                    })
                  );
                }}
              /> */}
              <Dropdown
                options={
                  types ? types.vehicleTypes?.map((typ: any) => typ?.type) : []
                }
                onChange={(item) => {
                  console.log(item);
                  dispatch(
                    setVehicle({
                      vehicleType: item.value,
                    })
                  );
                }}
                value={vinDetails?.vehicleType ?? ""}
                placeholder="Select an option"
                className="w-full border h-12 border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-"
                controlClassName=" accent-bg h-full"
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Color
              </label>
              {/* <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Color"
                required
                value={vinDetails?.color}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      color: e.target.value,
                    })
                  );
                }}
              /> */}
              <Dropdown
                options={
                  colors
                    ? colors.vehicleColors?.map((col: any) => col?.color)
                    : []
                }
                onChange={(item) => {
                  console.log(item);
                  dispatch(
                    setVehicle({
                      color: item.value,
                    })
                  );
                }}
                value={vinDetails?.color ?? ""}
                placeholder="Select an option"
                className="w-full border h-12 border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-"
                controlClassName="accent-bg h-full"
              />
            </div>
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Year
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Year"
                required
                value={vinDetails?.year ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      year: Number(e.target.value),
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Seating Capacity
              </label>
              {/* <input
                type="number"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Seating Capacity"
                required
                value={vinDetails?.capacity}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      capacity: Number(e.target.value),
                    })
                  );
                }}
              /> */}
              <Dropdown
                options={
                  capacity
                    ? capacity.vehicleCapacities
                        ?.map((cap: any) => cap?.capacity)
                        .sort((a: number, b: number) => a - b)
                    : []
                }
                onChange={(item) => {
                  // console.log(item);
                  dispatch(
                    setVehicle({
                      capacity: Number(item.value),
                    })
                  );
                }}
                value={vinDetails?.capacity ? `${vinDetails?.capacity}` : ""}
                placeholder="Select an option"
                className="w-full border h-12 border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-"
                controlClassName="accent-bg h-full"
              />
            </div>
            {/* <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Seats
              </label>
              <input
                type="number"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Seats"
                required
                value={vinDetails?.seats}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      seats: Number(e.target.value),
                    })
                  );
                }}
              />
            </div> */}
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Mileage per charge
              </label>
              <input
                type="number"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Mileage per charge"
                required
                value={vinDetails?.millagePerCharge ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      millagePerCharge: Number(e.target.value),
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Plate Number
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Number Plate"
                required
                value={vinDetails?.vehiclePlateNumber ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      vehiclePlateNumber: e.target.value,
                    })
                  );
                }}
              />
            </div>
            <div className="flex lg:w-1/2 flex-col">
              <label htmlFor="" className="block">
                Registration Good Thru
              </label>
              <div className="flex gap-2">
                <select
                  title="Select Registration Year"
                  className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3 h-12"
                  value={vinDetails?.registrationInfo?.split("-")[0] ?? ""}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    const year = e.target.value;
                    const month =
                      vinDetails?.registrationInfo?.split("-")[1] ?? "01";
                    dispatch(
                      setVehicle({
                        registrationInfo: `${year}-${month}`,
                      })
                    );
                  }}
                >
                  {Array.from({ length: 10 }, (_, i) => (
                    <option key={i} value={new Date().getFullYear() + i}>
                      {new Date().getFullYear() + i}
                    </option>
                  ))}
                </select>
                <select
                  title="Select Registration Month"
                  className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3 h-12"
                  value={vinDetails?.registrationInfo?.split("-")[1] ?? ""}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    const month = e.target.value;
                    const year =
                      vinDetails?.registrationInfo?.split("-")[0] ??
                      new Date().getFullYear();
                    dispatch(
                      setVehicle({
                        registrationInfo: `${year}-${month}`,
                      })
                    );
                  }}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={(i + 1).toString().padStart(2, "0")}>
                      {new Date(0, i).toLocaleString("default", {
                        month: "long",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex w-full flex-col">
              <label htmlFor="" className=" block ">
                Vehicle Registration Number
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Vehicle Registration Number"
                required
                value={vinDetails?.registrationNumber ?? ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      registrationNumber: e.target.value,
                    })
                  );
                }}
              />
            </div>
          </div>

          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex w-full flex-col">
              <label htmlFor="" className=" flex justify-between items-center ">
                Vehicle Description
                <span className="">
                  {vinDetails?.description?.length
                    ? stripHtml(vinDetails?.description)?.length
                    : 0}{" "}
                  / 512
                </span>
              </label>
              <ReactQuill
                theme="snow"
                value={vinDetails?.description ?? ""}
                onChange={(value) => {
                  // console.log(value, typeof value);
                  // console.log(vinDetails?.description, value);

                  if (stripHtml(value).length > 512) return;
                  dispatch(
                    setVehicle({
                      description: value,
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex w-full flex-col">
              <label htmlFor="" className=" block ">
                Other vehicle features
              </label>
              <Select
                options={[
                  ...features?.vehicleExtraFeatures?.map((feature: any) => ({
                    label: feature?.feature,
                    value: feature?.feature,
                  })),
                  ...[{ label: "Others", value: "Others" }],
                ]}
                isClearable
                isSearchable
                isMulti
                placeholder="Select other features"
                className="focus-visible:ring-transparent outline-none accent-bg"
                value={vinDetails?.extraFeatures?.map((feature: string) => ({
                  label: feature,
                  value: feature,
                }))}
                onChange={(value) => {
                  // console.log(value);
                  dispatch(
                    setVehicle({
                      extraFeatures: value?.map(
                        (value) =>
                          // ...vinDetails?.extraFeatures,
                          value.value
                      ),
                    })
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VinDetails;
